import { Dispatch } from 'redux';
import {
  Action,
  ActionPayloadRequest,
  DispatcherAuthPrefix,
  DispatcherCategoryService,
  DispatcherResource
} from 'modules/types/common';
import { getDispatcherUrl } from 'modules/utils/UrlUtils';
import { DFDHeaders } from 'serverTypes/authentication';
import { Thunk } from 'store/types';
import { visitSummaryFullListRequestStateSelector } from './selectors';
import * as actions from './actions.common';

export const getVisitSummaryFullList = (
  useCache = true,
  useRequestState = true,
  actionType = actions.GET_VISIT_SUMMARY_FULL_LIST
): Thunk => async (dispatch: Dispatch) => {
  const request: ActionPayloadRequest = {
    method: 'get',
    url: getDispatcherUrl(
      DispatcherCategoryService.HEALTH_RECORDS,
      DispatcherAuthPrefix.AUTHENTICATED,
      DispatcherResource.VISIT_SUMMARIES
    )
  };

  if (!useCache) {
    request.headers = {
      [DFDHeaders.cacheControl]: 'no-cache',
      [DFDHeaders.mhpCacheControl]: 'no-cache'
    };
  }

  dispatch({
    type: actionType,
    payload: {
      useRequestState,
      requestStateSelector: visitSummaryFullListRequestStateSelector,
      cache: useCache,
      client: 'dispatcher',
      request
    }
  } as Action);
};

export * from './actions.common';
